var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          attrs: {
            "element-loading-spinner": "el-icon-loading",
            data: _vm.parentList,
            border: "",
            "max-height": _vm.$tableMaxHeight,
            "header-cell-style": _vm.headerCellStyle,
            "element-loading-text": _vm.$tableLoading,
            "element-loading-background": "rgba(255,255,255, 0)",
          },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "16px",
                        color: "#43a0ff",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _c("span", [_vm._v(" Không có dữ liệu! ")]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Họ và tên phụ huynh" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.nameRepresentation))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Số điện thoại", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.numberPhone))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Đang học", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        _vm._l(
                          scope.row.kidsStudying.listKidsOfParent,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.fullName) +
                                  " - " +
                                  _vm._s(item.className) +
                                  " - " +
                                  _vm._s(item.gradeName) +
                                  "\n              "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      scope.row.kidsStudying.numberKidsStatus > 0
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.kidsStudying.numberKidsStatus
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Chờ học", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        _vm._l(
                          scope.row.kidsWaitingToLearn.listKidsOfParent,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.fullName) +
                                  " - " +
                                  _vm._s(item.className) +
                                  " - " +
                                  _vm._s(item.gradeName) +
                                  "\n              "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      scope.row.kidsWaitingToLearn.numberKidsStatus > 0
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.kidsWaitingToLearn.numberKidsStatus
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Bảo lưu", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        _vm._l(
                          scope.row.kidsReserve.listKidsOfParent,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.fullName) +
                                  " - " +
                                  _vm._s(item.className) +
                                  " - " +
                                  _vm._s(item.gradeName) +
                                  "\n              "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      scope.row.kidsReserve.numberKidsStatus > 0
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.kidsReserve.numberKidsStatus) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Nghỉ học", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        _vm._l(
                          scope.row.kidsLeaveSchool.listKidsOfParent,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.fullName) +
                                  " - " +
                                  _vm._s(item.className) +
                                  " - " +
                                  _vm._s(item.gradeName) +
                                  "\n              "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      scope.row.kidsLeaveSchool.numberKidsStatus > 0
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.kidsLeaveSchool.numberKidsStatus
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Ra trường", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        _vm._l(
                          scope.row.kidsOutSchool.listKidsOfParent,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.fullName) +
                                  " - " +
                                  _vm._s(item.className) +
                                  " - " +
                                  _vm._s(item.gradeName) +
                                  "\n              "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                      scope.row.kidsOutSchool.numberKidsStatus > 0
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.kidsOutSchool.numberKidsStatus
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Tổng số con", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.numberOfChildren))]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }